import { Action } from '@/_core/fluxstore/types';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { snackbar } from '@/_core/app-components/use';
import { useStorymapStore } from '../../useModule';
import { StorymapState } from '../../types';
import { createMoveAnnotationCommand } from '../../../api/commands/factory/createAnnotationCommands';

const { registerMiddleware, registerReducer } = useStorymapStore();

export class ReorderAnnotations extends Action<StorymapState> {
    public static ACTION_TYPE = 'ReorderAnnotations';
    public constructor(public id: string, public newOrder: number) {
        super(ReorderAnnotations.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ReorderAnnotations): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createMoveAnnotationCommand(action),
        onError: () => {
            snackbar.showError('Move failed. Please refresh the page.');
            return true;
        },
    });

    return true;
};

const reducer = (state: StorymapState, action: ReorderAnnotations): void => {
    const annotation = state.annotations.find(x => x.id == action.id);

    const annotationsToReorder = state.annotations.filter((x) => x.order > annotation.order);
    annotationsToReorder.forEach((x) => x.order--);

    const annotationsToReorderInc = state.annotations.filter((x) => x.order >= action.newOrder);
    annotationsToReorderInc.forEach((x) => x.order++);

    annotation.order = action.newOrder;
};

//@ts-ignore
registerMiddleware(ReorderAnnotations.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ReorderAnnotations.ACTION_TYPE, reducer);
